import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, typography } = themeVariables;

export const empty = css`
  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  color: var(${colors.content.secondary});
`;
